;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import { buildQueryParams } from '@workspace/ui/lib';
import type { ApiResponse } from '@workspace/ui/types';
import fetchAPI from '@/lib/fetch-api';
import type {
  OrganisationInfo,
  UpdateCurrentOrganisationPayload,
  UpdateCurrentOrganisationResponse,
} from '@/types/organisation';

export const getOrganisationsByUserIds = async (
  userIds: number[]
): Promise<ApiResponse<OrganisationInfo[]>> => {
  const queryParams = buildQueryParams({ user_ids: userIds });

  const response = await fetchAPI<OrganisationInfo[]>(
    `${process.env.NEXT_PUBLIC_EOR_API_URL}/organisations/by-user-ids?${queryParams.toString()}`,
    {
      method: 'GET',
    }
  );

  if (!response.success) {
    throw new Error(response.error || response.message || 'Failed to fetch organisations');
  }

  return {
    ...response,
    message: response.message || 'Organisations fetched successfully',
  };
};

export const updateCurrentOrganisation = async (
  payload: UpdateCurrentOrganisationPayload
): Promise<ApiResponse<UpdateCurrentOrganisationResponse>> => {
  const response = await fetchAPI<UpdateCurrentOrganisationResponse>(
    '/api/auth/update-current-organisation',
    {
      method: 'PUT',
      body: JSON.stringify(payload),
    }
  );

  if (!response.success) {
    throw new Error(response.error || response.message || 'Failed to update current organisation');
  }

  return {
    ...response,
    message: response.message || 'Current organisation updated successfully',
  };
};
